module.exports = __webpack_public_path__ + "static/media/auth-logo.22c6fcec.jpg";